import React from 'react'
import { createPortal } from 'react-dom'

import { useBrandTheme } from 'services/Branding/hooks'

import type { DropdownAnimationProps, IDropdownCourseContent } from './DropdownCourse'
import ContentRootStyled from './styled/ContentStyled'

interface IDropdownCourseContentProps extends DropdownAnimationProps {
  children: React.ReactNode
  style: React.CSSProperties
  disbale?: boolean
  container?: HTMLElement
  type: IDropdownCourseContent['type']
  textError?: string
  styleType?: IDropdownCourseContent['styleType']
  id?: string
}

const DropdownCourseContent = React.forwardRef<HTMLDivElement, IDropdownCourseContentProps>(
  (
    {
      children,
      style,
      disbale,
      container = document.body,
      type,
      textError,
      styleType,
      id,
      ...rest
    },
    ref,
  ) => {
    const theme = useBrandTheme()
    const child = (
      <ContentRootStyled
        $disbale={disbale}
        $styleType={styleType}
        $theme={theme}
        $type={type}
        id={id}
        ref={ref}
        style={style}
        {...(type === 'tooltip' && { role: 'tooltip' })}
        {...(rest.animate && rest)}
      >
        {children}
      </ContentRootStyled>
    )
    return createPortal(child, container)
  },
)

DropdownCourseContent.displayName = 'DropdownCourseContent'
export default DropdownCourseContent
